import { types } from "./constants";

export const viewerActions = {
  initParams: () => ({ type: types.INIT_PARAMS }),
  addFiles: (payload) => ({ type: types.ADD_FILES, payload: payload }),
  handleChange: (e) => ({ type: types.HANDLE_CHANGE, payload: e.target }),
};
